
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw, Download, Filter } from 'lucide-react';
import { Payment } from '@/services/types';
import { PaymentFilters } from './PaymentFilters';
import { toast } from '@/components/ui/sonner';

interface PaymentActionsProps {
  fetchPayments: () => void;
  dataSource: 'supabase' | 'mock';
  setStatusFilter: (status: string | null) => void;
  payments: Payment[];
}

export const PaymentActions: React.FC<PaymentActionsProps> = ({ 
  fetchPayments, 
  dataSource, 
  setStatusFilter,
  payments
}) => {
  
  const handleExport = () => {
    if (payments.length === 0) {
      toast.error("Нет данных для экспорта");
      return;
    }
    
    // В реальном приложении здесь была бы логика экспорта данных
    toast.success("Экспорт данных начат");
    
    setTimeout(() => {
      toast.info("Функция экспорта находится в разработке");
    }, 2000);
  };

  return (
    <div className="flex items-center space-x-2">
      <Button 
        variant="outline" 
        size="sm" 
        onClick={fetchPayments}
        title="Обновить данные"
      >
        <RefreshCw className="h-4 w-4 mr-2" />
        Обновить данные
      </Button>
      
      <PaymentFilters setStatusFilter={setStatusFilter} />
      
      <Button 
        variant="outline" 
        size="sm" 
        onClick={handleExport}
        title="Экспорт данных"
      >
        <Download className="h-4 w-4 mr-2" />
        Экспорт
      </Button>
    </div>
  );
};
